<template>
  <VueContentLoading :height="maxHeight" :width="maxWidth">
    <rect
      :height="heroRowHeight"
      :rx="borderRadius"
      :ry="borderRadius"
      :width="maxWidth"
      :x="0"
      :y="0" />
    <rect v-for="recordRow in recordRows" :key="recordRow.key" v-bind="recordRow" />
  </VueContentLoading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  components: {
    VueContentLoading,
  },
  data() {
    return {
      borderRadius: 4,
      heroRowHeight: 100,
      recordRowCount: 3,
      recordRowHeight: 30,
      recordRowMargin: 5,
      recordRowWidth: 300,
      maxHeight: 250,
      maxWidth: 300,
    };
  },
  computed: {
    recordRows() {
      const output = [];
      for (let i = 0; i < this.recordRowCount; i += 1) {
        output.push({
          key: `recordRow_${i}`,
          height: this.recordRowHeight,
          rx: this.borderRadius,
          ry: this.borderRadius,
          width: this.recordRowWidth,
          x: 0,
          y: (this.heroRowHeight + this.recordRowMargin)
            + (this.recordRowHeight * i)
            + (this.recordRowMargin * i),
        });
      }
      return output;
    },
  },
};
</script>
